module.exports = __webpack_public_path__ + "img/oculus-button.ba27f0eb.svg";